<template>
  <b-modal
    v-model="isModalShow"
    title="Please Add Conversation Topic"
    hide-footer
    @hide="hide"
    size="md"
    centered
  >
    <InputText
      id="input-search-topics"
      placeholder="Search Topics"
      type="text"
      :icon="icon"
      v-model="textSearchTopics"
      @submit="handleCollapseTopics"
      @onkeypress="onSearchTopics"
      @focus="handleCollapseTopics(false)"
      v-bind:isValidate="
        multipleTopicEnable ? $v.selectedTopics.$error : $v.form.topicId.$error
      "
      :v="multipleTopicEnable ? $v.selectedTopics : $v.form.topicId"
      minValueMessage="กรุณาเลือก Topic"
    />
    <b-collapse
      :id="'collapse-topics'"
      v-model="visibleCollapseTopics"
      class="external-collapse"
    >
      <div v-for="(group, idx) in topicsOption" :key="idx">
        <div
          v-if="group.groupId !== 0 && group.groupId"
          v-b-toggle="'collapse-topics' + group.groupId"
          class="collapse-btn pt-2 pl-2 d-flex justify-content-between"
          @mousedown.prevent="() => {}"
        >
          <div class="topic-group-title">
            <p :class="getGroupClass(group)">
              {{ group.groupName }}
            </p>
            <p v-if="getGroupCount(group) !== ''" class="circle ml-2">
              {{ " " + getGroupCount(group) }}
            </p>
          </div>
          <font-awesome-icon
            :icon="['fas', 'chevron-right']"
            class="mr-3 closed mt-2 mb-0"
          />
        </div>
        <div v-else>
          <div v-for="item in group.topics" :key="item.id">
            <b-dropdown-form v-if="multipleTopicEnable" class="px-2 py-1">
              <b-form-checkbox
                :id="`input_checkbox_${item.name}_${item.id}`"
                :name="`input_checkbox_${item.name}_${item.id}`"
                v-model="selectedTopics"
                :value="{
                  id: item.id,
                  name: item.name,
                  groupId: group.groupId
                }"
              >
                <span class="text-topics"> {{ item.name }}</span>
              </b-form-checkbox>
            </b-dropdown-form>
            <b-dropdown-item
              v-else
              :key="item.id"
              @click="handleSelectTopic(item)"
            >
              <span class="text-topics"> {{ item.name }}</span>
            </b-dropdown-item>
          </div>
        </div>

        <b-collapse
          :id="'collapse-topics' + group.groupId"
          :visible="openGroups.includes(group.groupId)"
        >
          <div v-for="topic in group.topics" :key="topic.id">
            <b-dropdown-form v-if="multipleTopicEnable" class="px-2 py-1">
              <b-form-checkbox
                :id="`input_checkbox_${topic.name}_${topic.id}`"
                :name="`input_checkbox_${topic.name}_${topic.id}`"
                v-model="selectedTopics"
                :value="{
                  id: topic.id,
                  name: topic.name,
                  groupId: group.groupId
                }"
              >
                <span class="text-topics">
                  {{ topic.name }}</span
                ></b-form-checkbox
              >
            </b-dropdown-form>
            <b-dropdown-item
              v-else
              @click="handleSelectTopic(topic)"
              :key="topic.name + topic.id"
              ><span class="text-topics">
                {{ topic.name }}</span
              ></b-dropdown-item
            >
          </div>
        </b-collapse>
      </div></b-collapse
    >
    <b-row>
      <b-col class="text-right">
        <b-button variant="outline-primary" @click="hide">
          Cancel
        </b-button>
      </b-col>
      <b-col>
        <b-button variant="main-primary" @click="selectConversationTopic">
          Comfirm
        </b-button></b-col
      >
    </b-row>
  </b-modal>
</template>

<script>
// import VueSelect from "@/components/inputs/VueSelect";
import { mapGetters } from "vuex";
import { required, minValue, minLength } from "vuelidate/lib/validators";
import InputText from "@/components/inputs/InputText";
import debounce from "lodash/debounce";
export default {
  name: "ChatBoxModalConversationTopic",
  props: {
    chatRoomId: {
      required: false,
      type: Array
    },
    selectedTopicId: {
      required: false,
      type: [String, Number]
    },
    multipleTopicEnable: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  components: {
    // VueSelect,
    InputText
  },
  data() {
    return {
      forceRefresh: true,
      loadFlag: false,
      isModalShow: false,
      form: {
        topicId: 0
      },
      mode: 0,
      textSearchTopics: "",
      topicsOption: [],
      selectedTopic: {},
      visibleCollapseTopics: false,
      selectedTopics: [],
      openGroups: []
    };
  },
  validations() {
    return {
      form: {
        topicId: {
          required,
          minValue: minValue(1)
        }
      },
      selectedTopics: {
        required,
        length: minLength(1)
      }
    };
  },

  watch: {
    textSearchTopics: debounce(function(val) {
      this.onSearchTopics();
      if ((!val || val === "") && this.selectedTopic.id) {
        this.clearTopic();
      }
    }, 200),
    visibleCollapseTopics(val) {
      if (
        val === false &&
        this.multipleTopicEnable &&
        this.selectedTopics.length > 0
      ) {
        this.textSearchTopics = this.selectedTopics
          .map(item => item.name)
          .join(", ");
      }
    }
  },

  computed: {
    ...mapGetters({
      brandId: "getBrand",
      topicList: "getConversationTopicList"
    }),

    icon() {
      return this.selectedTopic.id
        ? "times"
        : !this.visibleCollapseTopics
        ? "chevron-down"
        : "chevron-up";
    }
  },
  methods: {
    clearTopic() {
      this.form.topicId = 0;
      this.selectedTopic = {};
      this.textSearchTopics = "";
      this.onSearchTopics();
    },
    onSearchTopics: function() {
      const searchText = this.textSearchTopics?.toLowerCase() || "";

      if (!searchText) {
        this.topicsOption = this.topicList;
        this.openGroups = [];
        return;
      }

      this.topicsOption = this.topicList
        .map(group => {
          const matchedTopics = group.topics?.filter(
            topic =>
              topic.name.toLowerCase().includes(searchText) ||
              topic.groupName?.toLowerCase().includes(searchText)
          );

          if (matchedTopics?.length) {
            return {
              ...group,
              topics: matchedTopics
            };
          }
          return null;
        })
        .filter(group => group !== null);

      this.openGroups = this.topicsOption.map(g => g.groupId);
    },
    hide() {
      this.textSearchTopics = "";
      this.selectedTopic = {};
      this.isModalShow = false;
      this.form.topicId = 0;
      this.selectedTopics = [];
      this.openGroups = [];
      this.$v.form.$reset();
    },
    getGroupClass(group) {
      return group.topics.some(topic =>
        this.selectedTopics.some(selected => selected.id === topic.id)
      )
        ? "text-selected-topic"
        : "text-topics";
    },

    getGroupCount(group) {
      const count = group.topics.filter(topic =>
        this.selectedTopics.some(selected => selected.id === topic.id)
      ).length;
      return count > 0 ? count : "";
    },
    handleCollapseTopics(clearFlag = true) {
      if (this.selectedTopic.id && clearFlag) {
        this.clearTopic();
      }
      this.visibleCollapseTopics = !this.visibleCollapseTopics;
    },
    show(mode) {
      this.mode = mode;
      this.isModalShow = true;
      this.visibleCollapseTopics = false;
      this.topicsOption = this.topicList;
    },
    // onDataChange(val) {
    //   this.form.topicId = val;
    // },
    handleSelectTopic(val) {
      this.selectedTopic = { ...val };
      this.textSearchTopics = val.name;
      this.form.topicId = val.id;
      this.visibleCollapseTopics = false;
    },
    selectConversationTopic() {
      if (!this.multipleTopicEnable) {
        this.$v.form.$touch();
        if (this.$v.form.$error) return;
      } else {
        this.$v.selectedTopics.$touch();
        if (this.$v.selectedTopics.$error) return;
      }

      this.selelctConversationTopic();
    },
    async selelctConversationTopic() {
      let isEndChat = true;
      const topicId = !this.multipleTopicEnable ? this.form.topicId : null;
      const topic = !this.multipleTopicEnable ? this.form : null;
      const listTopics = this.multipleTopicEnable ? this.selectedTopics : null;
      await this.$emit(
        "selectedTopic",
        topicId,
        topic,
        isEndChat,
        this.mode,
        null,
        listTopics
      );
      await this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.line-clamp {
  word-break: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
::v-deep .col-ids {
  width: 105px !important;
  max-width: 105px !important;
  button {
    min-width: 80px;
  }
}
.btn-outline-primary {
  min-width: 150px;
}
.external-collapse {
  position: absolute;
  top: 43.7%; // ชิดด้านล่าง input
  left: 50;
  width: 93%;
  z-index: 1051;
  background: white;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 10px;

  max-height: 300px;
  overflow-y: auto;
}

@media (max-width: 767.98px) {
  ::v-deep .table-main {
    .col-name {
      min-width: 190px;
    }
  }
  .external-collapse {
    width: 90%;
    max-height: 250px;
  }
}
li {
  list-style-type: none;
  padding: 0;
}
.not-collapsed > .closed {
  transform: rotate(90deg);
  transition: 0.2s all;
}

.collapsed > .closed {
  transform: rotate(0deg);
  transition: 0.2s all;
}
.circle {
  width: 20px;
  border-radius: 50%;
  color: #fff;
  text-align: center;
  background: #832abf;
  margin-bottom: 0;
}

.topic-group-title {
  display: flex;
  justify-content: start;
  align-items: center;
  height: 20px;
}
.text-topics {
  width: 200px;
  margin-bottom: 0;
}
.text-selected-topic {
  color: #832abf;
  font-weight: bold;
  margin-bottom: 0;
}
</style>
